import React, { useState, useEffect, useRef, useCallback } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import {
  GET_SCHEPASSENGER_LIST,
  GET_LOCATION_URL,
  // GET_DRIVER_URL,
  GET_DRIVER_URL_V1,
  CHECK_DRIVER_AVAILABILITY,
  CANCEL_SCHEDULE,
  GET_NEMT_SERVICES_V1,
  GET_SERVICE_AUTH_ACTIVE,
  UPDATE_SCHEDULE_V1,
} from '../../constant';
import axios from 'axios';
import Swal from '../../messageBox/customSweetAlert';
import { dateFormat, restrictNumberInput, onlyNumberInput, restrictSpecialCharacters } from "../../utils";
import DatePicker from "react-datepicker";
import { useParams } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import PopupModal from '../../components/popupModal';
import ReusableModal from '../../components/ModalContent/ReusableModal';
import EditLocationContent from '../../components/ModalContent/EditLocationContent';
import EditableDropDown from '../../components/EditableDropDown';
import calender from '../../assets/images/calendar.png';
import SelectDropDown from '../../components/SelectDropDown';
import SaveButton from '../../components/buttons/SaveButton';
import CancelButton from '../../components/buttons/CancelButton';
import { currentDateFormat } from "../../utils";
import { useNavigate } from "react-router-dom";
import { scheduleFormValidation, validateLegs, validateEditAccordion } from "../../validation/Validation";
import { Circles } from 'react-loader-spinner';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';

// Precompute 5-minute interval time options in 12-hour format (e.g., "01:05 AM")
const TIME_OPTIONS_5_MIN = (() => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 5) {
      const period = hour < 12 ? 'AM' : 'PM';
      const hour12 = hour % 12 === 0 ? 12 : hour % 12;
      const hourStr = String(hour12).padStart(2, '0');
      const minuteStr = String(minute).padStart(2, '0');
      times.push(`${hourStr}:${minuteStr} ${period}`);
    }
  }
  return times;
})();

const ScheduleEditUpdated = () => {
  const prevAccordionsRef = useRef();
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const datepickerRef = useRef(null);

  const [passengers, setPassengers] = useState([]);
  const [selectedPassenger, setSelectedPassenger] = useState({ label: '', value: {} });
  const [filteredPassenger, setFilteredPassenger] = useState(null);
  const [location, setLocation] = useState([]);
  const [scheduleDate, setScheduleDate] = useState();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [assignedDriver, setAssignedDriver] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [pickUpLocation, setPickUplocation] = useState(null);
  const [dropOffLocation, setDropOffLocation] = useState(null);
  const [pickUpTime, setPickUpTime] = useState(null);
  const [dropOffTime, setDropOffTime] = useState(null);
  const [viewDetails, setViewDetails] = useState();
  const [locationValue, setLocationValue] = useState({
    loc_address: '',
    loc_city: '',
    loc_name: '',
    loc_state: '',
    loc_type: '',
    loc_zip: '',
    pass_id: ''
  });

  // Enhanced scheduleDetails with all fields from UpdatedSchedule
  const [scheduleDetails, setScheduleDetails] = useState({
    schedule_date: '',
    location_type: '',
    assigned_driver: '',
    number_of_leg: '2',
    bill_amount: '',
    date_mode: 'single',
    // Wait time defaults
    hour: '00',
    minute: '00',
    frequency: 'daily',
    selectedDays: [],
    has_companions: 'No',
    companion_count: '',
    transport_type: '', // Added from UpdatedSchedule
    transport_option: '', // Added from UpdatedSchedule
    appt_time: '', // Added from UpdatedSchedule
    ma_service_auth_id: '', // For MA payer: selected active service authorization id
    deadhead_miles: '', // Other Trip Details fields
    one_way: '1', // Set default to "No"
    door_assist: '',
    is_wait: '',
    leg_one_text: '', // Add leg_one_text field
    service_rate_id: null,
  });

  const [setValue, setSetValue] = useState(false);
  const [locationDetails, setLocationDetails] = useState();
  const [accordionsWithError, setAccordionsWithError] = useState([]);
  const [isWait, setIsWait] = useState('');
  const [isEditingWaitHour, setIsEditingWaitHour] = useState(false);
  const [isEditingWaitMinute, setIsEditingWaitMinute] = useState(false);
  const [totalDistance, setTotalDistance] = useState('');
  const [pickupAddress, setPickupAddress] = useState('');
  const [dropoffAddress, setDropoffAddress] = useState('');
  const [allLocations, setAllLocations] = useState([]);
  const [overlapedTimes, setOverlapedTimes] = useState([]);
  const [locationErrors, setLocationErrors] = useState({});
  const [hasCompanions, setHasCompanions] = useState('No');
  const [companionCount, setCompanionCount] = useState('');
  const [transportOptions, setTransportOptions] = useState([]);
  const [loadingTransportOptions, setLoadingTransportOptions] = useState(false);
  const [activeServiceAuthList, setActiveServiceAuthList] = useState([]);
  const [loadingActiveServiceAuth, setLoadingActiveServiceAuth] = useState(false);
  const prevLeg1AssignedDriverRef = useRef('');
  const prevScheduledMilesLeg1Ref = useRef('');
  const initialMATransServicesNameRef = useRef(''); // MA: preselect Service Type from schedule.trans_services_name
  const initialMAServiceTypeIdRef = useRef(''); // MA: preselect by schedule.trans_type_option (service_type_id)
  const [disabledInput, setDisabledInput] = useState(true);
  const [locationTypes, setLocationTypes] = useState({});
  const [editLocationOpen, setEditLocationOpen] = useState(false);

  // New state variables for enhanced functionality
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [frequency, setFrequency] = useState('daily');
  const [selectedDays, setSelectedDays] = useState([]);

  // State for ride_id in accordions
  const [rideIdFields, setRideIdFields] = useState({});

  // ACCORDION SETUP
  const [maxLegs, setMaxLegs] = useState(0);
  const [accordions, setAccordions] = React.useState([
    {
      id: 1, expanded: true, name: '', address: '', distance: 0, ride_id: '', assigned_driver: '', scheduled_miles: '',
      pickup_latitude: '', pickup_longitude: '', dropoff_latitude: '', dropoff_longitude: ''
    },
    {
      id: 2, expanded: false, name: '', address: '', distance: 0, ride_id: '', assigned_driver: '', scheduled_miles: '',
      pickup_latitude: '', pickup_longitude: '', dropoff_latitude: '', dropoff_longitude: ''
    }
  ]);

  // Function to add a new Accordion
  const handleAddAccordion = () => {
    if (accordions.length < maxLegs) {
      const newId = accordions.length + 1;
      setAccordions([...accordions, {
        id: newId,
        expanded: false,
        distance: 0,
        ride_id: '',
        assigned_driver: accordions?.[0]?.assigned_driver ?? '',
        scheduled_miles: accordions?.[0]?.scheduled_miles ?? '',
        pickup_latitude: '',
        pickup_longitude: '',
        dropoff_latitude: '',
        dropoff_longitude: ''
      }]);
    }
  };

  // Function to toggle an Accordion's expanded state
  const handleToggle = (id) => {
    setAccordions((prev) =>
      prev.map((accordion) =>
        accordion.id === id ? { ...accordion, expanded: true } : { ...accordion, expanded: false }
      )
    );
  };

  // Handle input changes for each Accordion
  const handleAccordianInputChange = async (id, field, value) => {
    if (field === "number_of_leg") {
      const numLegs = parseInt(value);
      setMaxLegs(numLegs);
      const currentAccordionsLength = accordions.length;
      if (currentAccordionsLength < numLegs) {
        const leg1Driver = accordions?.[0]?.assigned_driver ?? '';
        const leg1Miles = accordions?.[0]?.scheduled_miles ?? '';
        const newAccordions = Array.from({ length: (numLegs - currentAccordionsLength) }, (_, index) => ({
          id: currentAccordionsLength + index + 1,
          expanded: false,
          distance: 0,
          ride_id: '',
          assigned_driver: leg1Driver,
          scheduled_miles: leg1Miles,
          pickup_latitude: '',
          pickup_longitude: '',
          dropoff_latitude: '',
          dropoff_longitude: ''
        }));
        setAccordions([...accordions, ...newAccordions]);
      } else {
        setAccordions([...accordions.slice(0, numLegs)]);
      }

      setScheduleDetails((prev) => ({
        ...prev,
        number_of_leg: numLegs,
        [field]: value
      }));
    } else {
      if (field === 'assigned_driver') {
        if (id === 1) {
          const prevLeg1 = prevLeg1AssignedDriverRef.current;
          prevLeg1AssignedDriverRef.current = value;
          setAccordions((prev) =>
            prev.map((acc) => {
              if (acc.id === 1) return { ...acc, assigned_driver: value };
              if (!acc.assigned_driver || acc.assigned_driver === prevLeg1) {
                return { ...acc, assigned_driver: value };
              }
              return acc;
            })
          );
        } else {
          setAccordions((prev) =>
            prev.map((acc) => (acc.id === id ? { ...acc, assigned_driver: value } : acc))
          );
        }
        setErrors((prev) => {
          const next = { ...(prev || {}) };
          if (next[id]?.assigned_driver) next[id] = { ...next[id], assigned_driver: null };
          return next;
        });
        return;
      }

      if (field === 'scheduled_miles') {
        const sanitized = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
        if (id === 1) {
          const prevLeg1 = prevScheduledMilesLeg1Ref.current;
          prevScheduledMilesLeg1Ref.current = sanitized;
          setAccordions((prev) =>
            prev.map((acc) => {
              if (acc.id === 1) return { ...acc, scheduled_miles: sanitized };
              const shouldSync = acc.scheduled_miles === '' || acc.scheduled_miles === prevLeg1;
              return shouldSync ? { ...acc, scheduled_miles: sanitized } : acc;
            })
          );
        } else {
          setAccordions((prev) =>
            prev.map((acc) => (acc.id === id ? { ...acc, scheduled_miles: sanitized } : acc))
          );
        }
        setErrors((prev) => {
          const next = { ...(prev || {}) };
          if (next[id]?.scheduled_miles) next[id] = { ...next[id], scheduled_miles: null };
          if (next.schedule_miles) delete next.schedule_miles;
          return next;
        });
        return;
      }

      let localAccordions = [...accordions];

      localAccordions = localAccordions.map((accordion) => {
        if (accordion.id === id) {
          const updatedAccordion = { ...accordion, [field]: value };
          // Handle leg dependencies
          if (id === 1 && field === 'pick_up_loc') {
            const leg2 = localAccordions.find(a => a.id === 2);
            if (leg2) {
              localAccordions[1].drop_off_loc = value;
            }
          }
          if (id === 1 && field === 'drop_off_loc') {
            const leg2 = localAccordions.find(a => a.id === 2);
            if (leg2) {
              localAccordions[1].pick_up_loc = value;
            }
          }
          return updatedAccordion;
        }
        return accordion;
      });

      // Location validation
      localAccordions.forEach(accordion => {
        const pickUp = accordion.pick_up_loc;
        const dropOff = accordion.drop_off_loc;

        if (pickUp && dropOff && Number(pickUp) === Number(dropOff)) {
          setLocationErrors((prev) => ({
            ...prev,
            [accordion.id]: 'Pickup and Drop-off locations cannot be the same.'
          }));
        } else {
          setLocationErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[accordion.id];
            return newErrors;
          });
        }
      });

      // Driver availability check
      if ((field === 'pick_up_time' || field === 'drop_off_time')) {
        const currentLegDriverId = localAccordions.find((a) => a.id === id)?.assigned_driver;
        const isDriverAvailable = await checkDriverAvailability(currentLegDriverId, moment(scheduleDate).format('YYYY-MM-DD'), value);

        if (isDriverAvailable === '400') {
          setOverlapedTimes((prevOverlapedTimes) => [...prevOverlapedTimes, id]);
          Swal.fire({
            title: 'Failed!',
            text: "A schedule already exists for the selected driver in the chosen time slot. Please update the existing schedule before assigning a new one.",
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        } else {
          setOverlapedTimes((prevOverlapedTimes) => prevOverlapedTimes.filter((item) => item !== id));
        }
      }

      // Trigger distance calculation when locations change
      if (field === 'pick_up_loc' || field === 'drop_off_loc') {
        console.log(`Location changed for accordion ${id}: ${field} = ${value}`);
      }

      // Handle ride_id field separately
      if (field === 'ride_id') {
        setRideIdFields(prev => ({
          ...prev,
          [id]: value
        }));
      }

      setAccordions(localAccordions);
    }
    setScheduleDetails((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));

    // Wait time input validation/formatting
    if (name === 'hour' || name === 'minute') {
      const maxValue = name === 'hour' ? 24 : 59;
      let digits = (value ?? '').toString().replace(/\D/g, '').slice(0, 2);
      if (digits !== '' && Number(digits) > maxValue) {
        digits = String(maxValue);
      }

      setScheduleDetails((prev) => ({
        ...prev,
        [name]: digits,
        pass_id: selectedPassenger.value?.passenger?.passenger_id ?? '',
      }));
      return;
    }

    // When wait time is toggled, reset hour/minute to 00:00
    if (name === 'is_wait') {
      setIsWait(value);
      setScheduleDetails((prev) => ({
        ...prev,
        [name]: value,
        hour: '00',
        minute: '00',
        pass_id: selectedPassenger.value?.passenger?.passenger_id ?? '',
      }));
      return;
    }

    // Handle One Way logic
    if (name === 'one_way') {
      if (value === '2') { // Yes - One Way
        // Set number of legs to 1 and update accordions
        handleAccordianInputChange(accordions.id, 'number_of_leg', '1');
      } else { // No - Round Trip
        // Set number of legs back to 2 and update accordions
        handleAccordianInputChange(accordions.id, 'number_of_leg', '2');
      }
    }

    setScheduleDetails((prev) => {
      return {
        ...prev,
        [name]: value,
        pass_id: selectedPassenger.value?.passenger?.passenger_id ?? '',
      }
    });

    if (name === 'location_type') {
      if (value === '5') {
        setDisabledInput(false);
      } else {
        setDisabledInput(true);
      }
    }
  }

  const handleCompanionChange = (value) => {
    setHasCompanions(value);
    if (value === 'No') {
      setCompanionCount('');
    }
    setScheduleDetails(prev => ({
      ...prev,
      has_companions: value,
      companion_count: value === 'No' ? '' : companionCount
    }));
  };

  const handleCompanionCountChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setCompanionCount(value);
      setScheduleDetails(prev => ({
        ...prev,
        companion_count: value
      }));
    }
  };

  const fetchNemtTransportOptions = async (payerId) => {
    try {
      if (!payerId) {
        setTransportOptions([]);
        setLoadingTransportOptions(false);
        return;
      }

      setLoadingTransportOptions(true);
      const response = await axios.get(GET_NEMT_SERVICES_V1, {
        params: { payer: payerId },
      });
      const isOk =
        response?.data?.success === true ||
        response?.data?.status === 200 ||
        response?.data?.status === '200';

      if (isOk && Array.isArray(response?.data?.data)) {
        setTransportOptions(
          response.data.data.map((item) => ({
            id: item?.id,
            service_name: item?.serviceDetails?.service_name ?? '',
          })),
        );
      } else {
        setTransportOptions([]);
      }
    } catch (error) {
      console.error('Error fetching NEMT transport options:', error);
      setTransportOptions([]);
    } finally {
      setLoadingTransportOptions(false);
    }
  };

  const search = (event) => {
    setTimeout(() => {
      let _filteredPassengers;

      if (!event.query.trim().length) {
        _filteredPassengers = [...passengers];
      }
      else {
        const regex = new RegExp(`${event.query}`, "gi");
        _filteredPassengers = passengers.filter((user) => {
          return (
            user.first_name?.match(regex) || user.passenger.pass_pmi_no?.match(regex)
          );
        }).map((user) => {
          return {
            label: `${user.first_name} - ${user.passenger.pass_pmi_no}`,
            value: user
          };
        });
      }
      setFilteredPassenger(_filteredPassengers);
    }, 250);
  }

  const handleResetAddValue = () => {
    setLocationValue({});
  };

  const handleLocationSelect = async (passengerId) => {
    const response1 = await axios.get(GET_LOCATION_URL + `/${passengerId.value?.passenger?.passenger_id ?? ''}`);
    setLocation(response1.data);
    setAllLocations(response1.data);
  }

  // Function to get location type from allLocations
  const getLocationTypeFromAllLocations = (locationId) => {
    if (!locationId || !allLocations) return '';

    const location = allLocations.find(loc => loc.loc_id == locationId);

    return location?.locationType ? location?.locationType?.location_type_name : '';
  };

  // Function to update location types for accordions
  const updateLocationTypes = (accordionId, field, locationId) => {
    const locationType = getLocationTypeFromAllLocations(locationId);
    setLocationTypes(prev => ({
      ...prev,
      [`${accordionId}_${field}`]: locationType
    }));
  };

  const handleAccordiansData = (locationDetails) => {
    const orderedLegs = [...(locationDetails || [])].sort((a, b) => (a?.schedule_trans_id ?? 0) - (b?.schedule_trans_id ?? 0));
    const firstLegDriverId = orderedLegs?.[0]?.driver_id ? String(orderedLegs?.[0]?.driver_id) : '';
    const firstLegMiles = orderedLegs?.[0]?.distance ?? orderedLegs?.[0]?.miles ?? '';
    const newAccordions = orderedLegs.map((_, index) => ({
      id: index + 1,
      pick_up_time: _.pick_up_time,
      pick_up_loc: _.pick_up_location ?? _.pickupLocation?.loc_id ?? '',
      drop_off_time: _.drop_off_time,
      drop_off_loc: _.drop_off_location ?? _.dropoffLocation?.loc_id ?? '',
      ride_id: _.ride_id || '',
      assigned_driver: _.driver_id ? String(_.driver_id) : firstLegDriverId,
      scheduled_miles: String(_.distance ?? _.miles ?? firstLegMiles ?? ''),
      distance: _.distance || _.miles || 0,
      pickup_latitude: _.pickup_latitude || '',
      pickup_longitude: _.pickup_longitude || '',
      dropoff_latitude: _.dropoff_latitude || '',
      dropoff_longitude: _.dropoff_longitude || '',
      expanded: index === 0,
    }));

    setAccordions(newAccordions);
    prevLeg1AssignedDriverRef.current = newAccordions?.[0]?.assigned_driver ?? '';
    prevScheduledMilesLeg1Ref.current = newAccordions?.[0]?.scheduled_miles ?? '';

    // Initialize ride_id fields
    const rideIds = {};
    locationDetails.forEach((_, index) => {
      rideIds[index + 1] = _.ride_id || '';
    });
    setRideIdFields(rideIds);
  }

  const checkDriverAvailability = async (driverId, date, time) => {
    try {
      if (driverId && time != 'Will Call') {
        dispatch(setLoading(true));
        const response = await axios.post(CHECK_DRIVER_AVAILABILITY, {
          driverId,
          date,
          time,
          id
        });
        if (response.data.status === '200') {
          dispatch(setLoading(false));
          return response.data.status;
        } else {
          dispatch(setLoading(false));
          return response.data.status;
        }
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error('Error checking driver availability:', error);
      return false;
    }
  };

  // Load user data and form setup
  const loadUser = useCallback(async () => {
    dispatch(setLoading(true));
    const response = await axios.get(GET_SCHEPASSENGER_LIST);
    setPassengers(response.data);
    const response_2 = await axios.get(`${UPDATE_SCHEDULE_V1}${id}`);
    const response2 = await axios.post(GET_DRIVER_URL_V1);
    setAssignedDriver(response2?.data?.result);
    if (response_2.data) {
      const scheduleDataResp = response_2.data?.data || {};
      const legsResp = scheduleDataResp?.transData || [];
      handleAccordianInputChange(legsResp?.length || scheduleDataResp?.no_of_leg || 2, "number_of_leg", String(scheduleDataResp?.no_of_leg || legsResp?.length || 2));
      handleAccordiansData(legsResp);
      setSelectedPassenger({
        label: '', value: {
          address1: scheduleDataResp?.passenger?.address1,
          address2: scheduleDataResp?.passenger?.address2,
          city: scheduleDataResp?.passenger?.city,
          first_name: scheduleDataResp?.passenger?.firstName,
          middle_name: scheduleDataResp?.passenger?.middleName,
          mobile_no: scheduleDataResp?.passenger?.mobile_no,
          user_dob: scheduleDataResp?.passenger?.user_dob,
          passenger: {
            pass_insurance_no: scheduleDataResp?.passenger?.passenger?.pass_insurance_no,
            pass_payer: scheduleDataResp?.passenger?.passenger?.payerDetails?.payer_name ?? '',
            pass_pmi_no: scheduleDataResp?.passenger?.passenger?.pass_pmi_no,
            passenger_id: scheduleDataResp?.passenger?.passenger_id,
            payerDetails: scheduleDataResp?.passenger?.passenger?.payerDetails ?? null,
          }
        }
      });
      handleLocationSelect({ value: { passenger: { passenger_id: scheduleDataResp?.passenger?.passenger_id } } });
      setViewDetails(scheduleDataResp);
      //setScheduleDate(response_2.data.data.schedule.schedule_date);
      if (scheduleDataResp?.schedule_date) {
        const [year, month, day] = scheduleDataResp.schedule_date.split("-");
        setScheduleDate(new Date(year, month - 1, day));
      }
      setPickUpTime(legsResp?.[0]?.pick_up_time);
      setDropOffTime(legsResp?.[0]?.drop_off_time);
      setLocationDetails(legsResp);
      setSelectedValue(legsResp?.[0]?.driver?.firstName);
      setIsWait(scheduleDataResp?.is_wait);

      const normalizeWaitPart = (val, max) => {
        const digits = (val ?? '').toString().replace(/\D/g, '').slice(0, 2);
        const num = digits === '' ? 0 : Number(digits);
        const safe = isNaN(num) ? 0 : Math.min(max, Math.max(0, num));
        return String(safe).padStart(2, '0');
      };

      const scheduleData = {
        schedule_date: moment(scheduleDataResp?.schedule_date).format('MM/DD/YYYY'),
        assigned_driver: legsResp?.[0]?.driver_id ? String(legsResp?.[0]?.driver_id) : '',
        location_type: scheduleDataResp?.location_type,
        passenger_id: scheduleDataResp?.passenger?.passenger_id,
        number_of_leg: String(scheduleDataResp?.no_of_leg || legsResp?.length || 2),
        schedule_note: scheduleDataResp?.schedule_note,
        companion_number: scheduleDataResp?.companion,
        companion: scheduleDataResp?.companion ? true : false,
        other_location_type: scheduleDataResp?.location_type_others,
        leg_one_text: scheduleDataResp?.leg_one_text,
        is_wait: scheduleDataResp?.is_wait,
        hour: normalizeWaitPart(scheduleDataResp?.hour, 24),
        minute: normalizeWaitPart(scheduleDataResp?.minute, 59),
        bill_amount: scheduleDataResp?.bill_amount,
        scheduleId: id,
        has_companions: scheduleDataResp?.companion ? 'Yes' : 'No',
        companion_count: scheduleDataResp?.companion || '',
        transport_type: scheduleDataResp?.trans_type || '',
        transport_option: scheduleDataResp?.trans_type_option || '',
        appt_time: scheduleDataResp?.appt_time || '',
        ma_service_auth_id: scheduleDataResp?.ma_service_auth_id ?? '',
        deadhead_miles: scheduleDataResp?.dead_head_miles || '',
        one_way: String(scheduleDataResp?.one_way || '1'),
        door_assist: scheduleDataResp?.door_assist || '',
        leg_one_text: scheduleDataResp?.leg_one_text || '',
        payer: scheduleDataResp?.passenger?.passenger?.payerDetails?.payer_name || '',
        sa_number: scheduleDataResp?.sa_number ?? null,
      };


      setScheduleDetails(scheduleData);
      if (scheduleDataResp?.passenger?.passenger?.payerDetails?.payer_name === 'MA') {
        initialMATransServicesNameRef.current =
          scheduleDataResp?.trans_services_name ??
          scheduleDataResp?.nemtService?.service_name ??
          '';
        initialMAServiceTypeIdRef.current = String(scheduleDataResp?.trans_type_option ?? '');
      }
      setHasCompanions(scheduleDataResp?.companion ? 'Yes' : 'No');
      setCompanionCount(scheduleDataResp?.companion);
      setDisabledInput(scheduleDataResp?.location_type === '5' ? false : true);
      dispatch(setLoading(false));
    }
  }, [id]);

  useEffect(() => {
    loadUser();
  }, []);

  // Update location types when accordions change and allLocations is available
  useEffect(() => {
    if (allLocations && allLocations.length > 0) {
      accordions.forEach(accordion => {
        if (accordion.pick_up_loc) {
          updateLocationTypes(accordion.id, 'pickup', accordion.pick_up_loc);
        }
        if (accordion.drop_off_loc) {
          updateLocationTypes(accordion.id, 'dropoff', accordion.drop_off_loc);
        }
      });
    }
  }, [accordions, allLocations]);

  const isMAPayer = selectedPassenger?.value?.passenger?.pass_payer === 'MA';

  // Fetch NEMT transport options when non-MA payer is selected
  useEffect(() => {
    if (isMAPayer) {
      setTransportOptions([]);
      setLoadingTransportOptions(false);
      return;
    }
    const payerId = selectedPassenger?.value?.passenger?.payerDetails?.id;
    if (!payerId) {
      setTransportOptions([]);
      return;
    }
    fetchNemtTransportOptions(payerId);
  }, [isMAPayer, selectedPassenger?.value?.passenger?.payerDetails?.id]);
  useEffect(() => {
    if (!isMAPayer) {
      setActiveServiceAuthList([]);
      setScheduleDetails((prev) => ({ ...prev, ma_service_auth_id: '' }));
      setLoadingActiveServiceAuth(false);
      return;
    }
    const passengerId = selectedPassenger?.value?.passenger?.passenger_id;
    if (!passengerId) {
      setActiveServiceAuthList([]);
      setLoadingActiveServiceAuth(false);
      return;
    }
    let cancelled = false;
    setLoadingActiveServiceAuth(true);
    axios
      .get(`${GET_SERVICE_AUTH_ACTIVE}/${passengerId}`)
      .then((response) => {
        if (cancelled) return;
        if (response?.data?.status === '200' && Array.isArray(response?.data?.data)) {
          const data = response.data.data;
          setActiveServiceAuthList(data);
          const transServicesName = initialMATransServicesNameRef.current?.trim?.() || '';
          const serviceTypeId = String(initialMAServiceTypeIdRef.current || '');
          if ((transServicesName || serviceTypeId) && data.length > 0) {
            const matching =
              data.find(
                (item) => String(item?.service_type_id ?? item?.serviceType?.id ?? item?.id ?? '') === serviceTypeId
              ) ||
              data.find(
                (item) => (item?.serviceType?.service_name ?? '').trim() === transServicesName
              );
            if (matching) {
              setScheduleDetails((prev) => ({ ...prev, ma_service_auth_id: matching.id }));
            }
            initialMATransServicesNameRef.current = '';
            initialMAServiceTypeIdRef.current = '';
          }
        } else {
          setActiveServiceAuthList([]);
        }
      })
      .catch(() => {
        if (!cancelled) setActiveServiceAuthList([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingActiveServiceAuth(false);
      });
    return () => { cancelled = true; };
  }, [isMAPayer, selectedPassenger?.value?.passenger?.passenger_id]);

  // Form submission handler
  async function handleFormSubmit(e) {
    e.preventDefault();
    const allErrors = {};
    const accordionsWithError = [];

    setOverlapedTimes([]);
    if (overlapedTimes.length > 0) {
      Swal.fire({
        title: 'Failed!',
        text: "A schedule already exists for the selected driver in the chosen time slot. Please update the existing schedule before assigning a new one.",
        icon: 'warning',
        confirmButtonText: 'OK',
      }).then(() => {
        setOverlapedTimes([]);
      });
      return false;
    }

    if (Object.keys(locationErrors).length > 0) {
      Swal.fire({
        title: 'Failed',
        text: 'Please ensure pickup and drop-off locations are not the same.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return false;
    }

    const detailsToValidate = scheduleDetails;
    const isValid = scheduleFormValidation(detailsToValidate, { isMAPayer });
    setErrors(isValid);

    accordions.forEach((accordion) => {
      const legErrors = validateEditAccordion(accordion);
      const sm = accordion.scheduled_miles != null ? String(accordion.scheduled_miles).trim() : '';
      if (!sm) {
        legErrors.scheduled_miles = 'Scheduled miles is required.';
      } else {
        const n = Number(sm);
        if (!Number.isFinite(n) || n <= 0) {
          legErrors.scheduled_miles = 'Scheduled miles must be a valid number greater than zero.';
        }
      }
      if (Object.keys(legErrors).length > 0) {
        allErrors[accordion.id] = legErrors;
        accordionsWithError.push(accordion.id);
      }
    });

    const legValidationErrors = validateLegs(accordions);
    if (Object.keys(legValidationErrors).length > 0) {
      Object.keys(legValidationErrors).forEach((key) => {
        const legIndex = parseInt(key.match(/\d+/)[0], 10) - 1;
        if (!allErrors[accordions[legIndex].id]) {
          allErrors[accordions[legIndex].id] = {};
        }
        const errorKey = key.replace(/_\d+$/, '');
        allErrors[accordions[legIndex].id][errorKey] = legValidationErrors[key];
        if (!accordionsWithError.includes(accordions[legIndex].id)) {
          accordionsWithError.push(accordions[legIndex].id);
        }
      });
    }

    if (Object.keys(allErrors).length > 0) {
      setErrors(allErrors);
      setAccordionsWithError(accordionsWithError);
      return;
    }

    if (Object.keys(isValid).length === 0) {
      try {
        dispatch(setLoading(true));
        const scheduleDetailsForPayload = isMAPayer
          ? (() => {
              const { ma_service_auth_id, ...rest } = scheduleDetails;
              const selectedMAItem = activeServiceAuthList.find(
                (i) =>
                  String(i?.service_type_id ?? i?.serviceType?.id ?? '') ===
                    String(ma_service_auth_id) ||
                  String(i?.id ?? '') === String(ma_service_auth_id),
              );
              const serviceTypeId = selectedMAItem?.service_type_id ?? selectedMAItem?.serviceType?.id ?? '';
              const serviceRateId =
                selectedMAItem?.nemt_service_rate_id != null &&
                selectedMAItem?.nemt_service_rate_id !== ''
                  ? Number(selectedMAItem.nemt_service_rate_id)
                  : scheduleDetails.service_rate_id != null
                    ? Number(scheduleDetails.service_rate_id)
                    : null;
              return {
                ...rest,
                transport_type: '2',
                transport_option: serviceTypeId,
                sa_number: selectedMAItem?.sa_number ?? '',
                appt_time: scheduleDetails.appt_time || '12:00 AM',
                service_rate_id: serviceRateId,
              };
            })()
          : (() => {
              const { ma_service_auth_id, ...rest } = scheduleDetails;
              const serviceRateId =
                rest.transport_option != null && rest.transport_option !== ''
                  ? Number(rest.transport_option)
                  : scheduleDetails.service_rate_id != null
                    ? Number(scheduleDetails.service_rate_id)
                    : null;
              return {
                ...rest,
                transport_type: 2,
                service_rate_id: serviceRateId,
              };
            })();
        const generateSixDigitRideId = () => String(Math.floor(100000 + Math.random() * 900000));
        const accordionsForPayload = isMAPayer
          ? accordions.map((acc) => ({
            ...acc,
            assigned_driver:
              acc.assigned_driver != null && String(acc.assigned_driver).trim() !== ''
                ? String(acc.assigned_driver)
                : null,
            ride_id: acc.ride_id || generateSixDigitRideId(),
            distance: Number(acc.scheduled_miles) || 0,
          }))
          : accordions.map(accordion => ({
            ...accordion,
            assigned_driver:
              accordion.assigned_driver != null && String(accordion.assigned_driver).trim() !== ''
                ? String(accordion.assigned_driver)
                : null,
            ride_id: rideIdFields[accordion.id] || accordion.ride_id || '',
            distance: Number(accordion.scheduled_miles) || 0,
          }));

        const payload = {
          scheduleDetails: scheduleDetailsForPayload,
          accordions: accordionsForPayload,
        };
        const response = await axios.put(UPDATE_SCHEDULE_V1 + `${id}`, payload);

        if (response.data.status === '200') {
          dispatch(setLoading(false));
          navigate('/home/schedule/list/v1', { replace: true });
          Swal.fire({
            title: 'Success!',
            text: response.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          dispatch(setLoading(false));
          Swal.fire({
            title: 'Failed!',
            text: response.data.message,
            icon: 'Error',
            confirmButtonText: 'OK',
          });
        }
      } catch (error) {
        dispatch(setLoading(false));
        console.error("Error updating schedule:", error);
      }
    }
  }

  const handleCancelSchedule = () => {
    Swal.fire({
      title: 'Are you sure you want to cancel this schedule?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
        axios.post(CANCEL_SCHEDULE + '/' + `${id}`)
          .then((response) => {
            if (response.data.status === 200) {
              dispatch(setLoading(false));
              Swal.fire({
                title: 'Success!',
                text: response.data.message,
                icon: 'success',
                confirmButtonText: 'OK',
              });
              navigate('/home/schedule/list/v1', { replace: true })
            } else if (response.data.status === 400) {
              dispatch(setLoading(false));
              Swal.fire({
                title: '',
                text: response.data.message,
                icon: 'Error',
                confirmButtonText: 'OK',
              });
            }
          }).catch(error => {
            dispatch(setLoading(false));
            Swal.fire({
              title: 'Failed!',
              text: error.message,
              icon: 'Error',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
            });
          })
      }
    });
  }

  // Calculate if wait time fields should be shown
  const showWaitTimeFields = scheduleDetails.is_wait == '1' || isWait == '1' || scheduleDetails.is_wait === 1 || isWait === 1;

  const formatAddress = (source = {}) => {
    const root = (source && typeof source === 'object') ? source : {};
    const nested = (root.passenger && typeof root.passenger === 'object') ? root.passenger : {};

    const clean = (s) =>
      typeof s === 'string'
        ? s.trim().replace(/\s+/g, ' ').replace(/,+$/, '').replace(/^[, ]+|[, ]+$/g, '')
        : '';

    const pick = (...values) => {
      for (const v of values) {
        if (typeof v === 'string' && v.trim().length > 0) return clean(v);
      }
      return '';
    };

    const stateName = pick(
      root.state_master_lists?.state_name,
      root.state_master_list?.state_name,
      root.state_list?.state_name,
      root.state?.state_name,
      typeof root.state === 'string' ? root.state : undefined,
      nested.state_master_lists?.state_name,
      nested.state_master_list?.state_name,
      nested.state_list?.state_name,
      nested.state?.state_name,
      typeof nested.state === 'string' ? nested.state : undefined
    );

    const addr1 = pick(root.address1, root.address_1, root.address, root.pass_addr1, nested.address1, nested.address_1, nested.address, nested.pass_addr1);
    const addr2 = pick(root.address2, root.address_2, root.pass_addr2, nested.address2, nested.address_2, nested.pass_addr2);
    const city = pick(root.city, nested.city);
    const zip = pick(root.zip, nested.zip);

    // If all are empty
    if (!addr1 && !addr2 && !city && !stateName && !zip) return '';

    // ✅ Check if address1 already includes city/state/zip (full address)
    const hasFullAddress =
      (city && addr1.toLowerCase().includes(city.toLowerCase())) ||
      (stateName && addr1.toLowerCase().includes(stateName.toLowerCase())) ||
      (zip && addr1.toLowerCase().includes(zip));

    if (hasFullAddress) return addr1;

    // ✅ Skip address2 if same or contained within address1
    const finalAddr2 =
      addr2 &&
        addr2.toLowerCase() !== addr1.toLowerCase() &&
        !addr1.toLowerCase().includes(addr2.toLowerCase())
        ? addr2
        : null;

    // ✅ Build final formatted string
    return [addr1, finalAddr2, city, stateName, zip].filter(Boolean).join(', ');
  };


  return (
    <><div>
    </div><div className="tab-pane fade active show " id="create-schedule" role="tabpanel" aria-labelledby="profile-tab">
        <section>
          <div className='d-flex justify-content-between form-container'>
            <div>
              <h2 className="fs-5 font-weight-600">Edit Schedule</h2>
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <div className="container-fluid px-mobile-2 bg-white px-5 py-4">

          <section>
            <form action="#">
              {/* First Row */}
              <div className="row mb-3">
                <div className="col-3">
                  <div className="form-item">
                    <label>Passenger Name</label>
                    <input type="text" readOnly={true} className="form-control" value={selectedPassenger.value?.first_name ?? ''} id="client_name" name="client_name" />
                  </div>
                </div>
                <div className="col-3">
                  <div className="date-selector">
                    <label>Date of Birth</label>
                    <div className="input-group">
                      <input type="text" readOnly={true} className="form-control datepicker hasDatepicker" id="client-dob" name="client_date_of_birth"
                        value={(dateFormat(selectedPassenger.value?.user_dob)) ?? ''} />
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div>
                    <label>Payor</label>
                    <input type="text" readOnly={true} className="form-control" id="payer" name="payer"
                      value={selectedPassenger.value?.passenger?.pass_payer ?? ''} />
                  </div>
                </div>
                <div className="col-3">
                  <div>
                    <label>Member ID/Insurance Number</label>
                    <input type="text" readOnly={true} className="form-control" id="insurance_number" name="insurance_number"
                      value={selectedPassenger.value?.passenger?.pass_pmi_no ?? ''} />
                  </div>
                </div>
              </div>

              {/* Second Row */}
              <div className="row mb-3">
                <div className="col-6">
                  <div>
                    <label>Address</label>
                    <input type="text" className="form-control" readOnly={true} id="address" name="address"
                      value={formatAddress(selectedPassenger.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div>
                    <label>Phone Number</label>
                    <input type="text" className="form-control" readOnly={true} id="phone_number" name="phone-number"
                      value={selectedPassenger.value?.mobile_no ?? ''} />
                  </div>
                </div>
                <div className="col-3">
                  {/* Empty column for spacing */}
                </div>
              </div>
            </form>
          </section>

          <section>
            <div>
              <p className="sub-title">Edit Schedule</p>
            </div>

            <div className="add-new-trip">
              <form onSubmit={handleFormSubmit}>
                <div className='schedule-form-1'>
                  <div className="row">
                    <div className="d-flex gap-1">
                      <div className="col-1">
                        <label>One Way</label>
                        <div className="d-flex gap-1 align-items-center mt-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="one_way"
                              id="edit_one_way_yes"
                              value="2"
                              checked={scheduleDetails.one_way == '2'}
                              onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="edit_one_way_yes">Yes</label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="one_way"
                              id="edit_one_way_no"
                              value="1"
                              checked={scheduleDetails.one_way == '1'}
                              onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="edit_one_way_no">No</label>
                          </div>
                        </div>
                      </div>

                      {scheduleDetails.one_way == "2" && (
                        <div className="col-2">
                          <div>
                            <label>&nbsp;</label>
                            <input
                              type="text"
                              className="form-control"
                              id="leg_one_text"
                              name="leg_one_text"
                              placeholder="No Load"
                              autoComplete='off'
                              value={scheduleDetails.leg_one_text || ''}
                              onChange={handleInputChange}
                            />
                            {errors.leg_one_text && <span className="errors">{errors.leg_one_text}</span>}
                          </div>
                        </div>
                      )}

                      {scheduleDetails.one_way != "2" && (
                        <div className="col-1">
                          <label className='require-field'>No of Legs</label>
                          <div>
                            <select className="form-select" value={scheduleDetails?.number_of_leg} aria-label="Default select example" onChange={(e) => handleAccordianInputChange(accordions.id, 'number_of_leg', e.target.value)} name="number_of_leg">
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                            {errors.number_of_leg && <span className="errors">{errors.number_of_leg}</span>}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-2" style={{ display: 'none' }}>
                      <label className='require-field'>Bill Amount</label>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id="bill_amount"
                          name="bill_amount"
                          value={scheduleDetails.bill_amount}
                          placeholder="Enter amount"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                              handleInputChange(e);
                            }
                          }}
                        />
                        {errors.bill_amount && <span className="errors">{errors.bill_amount}</span>}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Render Accordions dynamically - same as original but with enhanced fields */}
                <section>
                  {accordions
                    .filter((accordion) => {
                      // If "One Way" is "Yes", only show Leg 1
                      if (scheduleDetails.one_way == '2') {
                        return accordion.id === 1;
                      }
                      // Otherwise show all accordions
                      return true;
                    })
                    .map((accordion) => (
                      <Accordion style={{ background: '#80808012' }} key={accordion.id} expanded={accordion.expanded || accordionsWithError.includes(accordion.id)} onChange={() => handleToggle(accordion.id)}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${accordion.id}-content`}
                          id={`panel${accordion.id}-header`}
                        >
                          <Typography>Leg {accordion.id}</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          <div>
                            {/* Leg 1 specific fields */}
                            {accordion.id === 1 && (
                              <>
                                <div className="row mb-3">
                                  <div className="col-2">
                                    <label className='require-field'>Trip Date</label>
                                    <div className="d-flex date-picker-wrapper">
                                      <div>
                                        <DatePicker
                                          selected={scheduleDate}
                                          dateFormat="MM/dd/yyyy"
                                          autoComplete='off'
                                          className="datepicker form-control hasDatepicker" id="schedule_date" name="schedule_date"
                                          onChange={(date) => {
                                            setScheduleDate(date);
                                            handleInputChange({ target: { name: 'schedule_date', value: `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` } });
                                          }}
                                          ref={datepickerRef}

                                        >
                                        </DatePicker>
                                      </div>
                                      <div className='date-picker-btn'>
                                        <button className="btn datepicker-button width-50"
                                          type="button"
                                          data-target="#schedule_date"
                                          id="schedule_date-btn"
                                          onClick={() => {
                                            datepickerRef.current.setOpen(true);
                                          }}
                                        >
                                          <img src={calender} className="img-fluid" width="20" height="20" alt="calender" />
                                        </button>
                                      </div>
                                    </div>
                                    {errors.schedule_date && <span className='errors'>{errors.schedule_date}</span>}
                                  </div>

                                  <div className='col-2'>
                                    <div>
                                      <label>Assign Driver</label>
                                      <select
                                        className="form-select"
                                        value={accordion.assigned_driver ?? ''}
                                        aria-label="Default select example"
                                        onChange={(e) => handleAccordianInputChange(accordion.id, 'assigned_driver', e.target.value)}
                                      >
                                        <option value="">Select</option>
                                        {assignedDriver.map((driver, index) => (
                                          <option key={index} value={driver?.driver_id}>{driver?.driver_name ?? driver?.full_name}</option>
                                        ))}
                                      </select>
                                    </div>
                                    {errors[accordion.id]?.assigned_driver && <span className="errors">{errors[accordion.id].assigned_driver}</span>}
                                  </div>

                                  {isMAPayer ? (
                                    <>
                                      <div className="col-2">
                                        <label className='require-field'> {isMAPayer ? 'Service Type' : 'Transport Options'} </label>
                                        <select
                                          className="form-select"
                                          value={scheduleDetails.ma_service_auth_id || ''}
                                          name="ma_service_auth_id"
                                          onChange={handleInputChange}
                                          disabled={loadingActiveServiceAuth}
                                        >
                                          <option value="">
                                            {loadingActiveServiceAuth ? 'Loading...' : 'Service Authorization'}
                                          </option>
                                          {activeServiceAuthList.map((item) => (
                                            <option key={item?.id} value={item?.id}>
                                              {item?.serviceType?.service_name ?? '—'}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-2">
                                        <label className='require-field'>Scheduled Miles</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name={`scheduled_miles_leg_${accordion.id}`}
                                          value={accordion.scheduled_miles ?? ''}
                                          onChange={(e) => handleAccordianInputChange(accordion.id, 'scheduled_miles', e.target.value)}
                                          placeholder="Enter miles"
                                          inputMode="decimal"
                                        />
                                        {errors[accordion.id]?.scheduled_miles && <span className="errors">{errors[accordion.id].scheduled_miles}</span>}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="col-2">
                                        <label className='require-field'>Transport Options</label>
                                        <select
                                          className="form-select"
                                          value={scheduleDetails.transport_option ?? ''}
                                          onChange={handleInputChange}
                                          name="transport_option"
                                          disabled={
                                            !selectedPassenger?.value?.passenger?.payerDetails?.id ||
                                            loadingTransportOptions
                                          }
                                        >
                                          <option value="">
                                            {loadingTransportOptions
                                              ? 'Loading services...'
                                              : 'Select Transport Option'}
                                          </option>
                                          {transportOptions.map((option) => (
                                            <option key={option?.id} value={option?.id ?? ''}>
                                              {option?.service_name ?? ''}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.transport_option && <span className="errors">{errors.transport_option}</span>}
                                      </div>
                                      <div className="col-2">
                                        <label className='require-field'>Ride ID / Conf#</label>
                                        <input
                                          type="text"
                                          autoComplete='off'
                                          className="form-control"
                                          name={`ride_id_leg_${accordion.id}`}
                                          value={accordion.ride_id || ''}
                                          onChange={(e) => handleAccordianInputChange(accordion.id, 'ride_id', e.target.value)}
                                          placeholder="Enter Ride ID"
                                        />
                                        {errors[accordion.id]?.ride_id && <span className="errors">{errors[accordion.id].ride_id}</span>}
                                      </div>
                                      <div className="col-2">
                                        <label className='require-field'>Scheduled Miles</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name={`scheduled_miles_leg_${accordion.id}`}
                                          value={accordion.scheduled_miles ?? ''}
                                          onChange={(e) => handleAccordianInputChange(accordion.id, 'scheduled_miles', e.target.value)}
                                          placeholder="Enter miles"
                                          inputMode="decimal"
                                        />
                                        {errors[accordion.id]?.scheduled_miles && <span className="errors">{errors[accordion.id].scheduled_miles}</span>}
                                      </div>
                                      <div className="col-2">
                                        <label className='require-field'>Appt. Time</label>
                                        <select name="appt_time" className="form-select" id="appt_time" value={scheduleDetails.appt_time} onChange={handleInputChange}>
                                          <option value="">Select</option>
                                          {TIME_OPTIONS_5_MIN.map((t) => (
                                            <option key={t} value={t}>{t}</option>
                                          ))}
                                        </select>
                                        {errors.appt_time && <span className="errors">{errors.appt_time}</span>}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )}

                            {/* First row for Leg 2+ */}
                            {accordion.id !== 1 && (
                              <div className="row mb-3">
                                <div className="col-2">
                                  <label>Assign Driver</label>
                                  <select
                                    className="form-select"
                                    value={accordion.assigned_driver ?? ''}
                                    onChange={(e) => handleAccordianInputChange(accordion.id, 'assigned_driver', e.target.value)}
                                  >
                                    <option value="">Select</option>
                                    {assignedDriver.map((driver, index) => (
                                      <option key={index} value={driver?.driver_id}>{driver?.driver_name ?? driver?.full_name}</option>
                                    ))}
                                  </select>
                                  {errors[accordion.id]?.assigned_driver && <span className="errors">{errors[accordion.id].assigned_driver}</span>}
                                </div>
                                {!isMAPayer && (
                                  <div className="col-2">
                                    <label className='require-field'>Ride ID / Conf#</label>
                                    <input
                                      autoComplete='off'
                                      type="text"
                                      className="form-control"
                                      name={`ride_id_leg_${accordion.id}`}
                                      value={accordion.ride_id || ''}
                                      onChange={(e) => handleAccordianInputChange(accordion.id, 'ride_id', e.target.value)}
                                      placeholder="Enter Ride ID"
                                    />
                                    {errors[accordion.id]?.ride_id && <span className="errors">{errors[accordion.id].ride_id}</span>}
                                  </div>
                                )}
                                <div className="col-2">
                                  <label className='require-field'>Scheduled Miles</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={`scheduled_miles_leg_${accordion.id}`}
                                    value={accordion.scheduled_miles ?? ''}
                                    onChange={(e) => handleAccordianInputChange(accordion.id, 'scheduled_miles', e.target.value)}
                                    placeholder="Enter miles"
                                    inputMode="decimal"
                                  />
                                  {errors[accordion.id]?.scheduled_miles && <span className="errors">{errors[accordion.id].scheduled_miles}</span>}
                                </div>
                              </div>
                            )}

                            <div className="row mt-4 pickup-time">
                              <div className="col-sm-12 col-md-8 col-lg-7 ps-2">
                                <div className="form-create-schedule">
                                  <div>
                                    <div>
                                      <label className='require-field'>Pick Up Time</label>
                                      <select name="pick_up_time" value={accordion.pick_up_time} className="form-select" id="pick_up_time" onChange={(e) => handleAccordianInputChange(accordion.id, 'pick_up_time', e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="Will Call">Will Call</option>
                                        {TIME_OPTIONS_5_MIN.map((t) => (
                                          <option key={t} value={t}>{t}</option>
                                        ))}
                                      </select>
                                      {errors[accordion.id]?.pick_up_time && <span className="errors">{errors[accordion.id].pick_up_time}</span>}
                                    </div>
                                  </div>

                                  <div>
                                    <label className='require-field'>Pick Up Location</label>
                                    <select className="form-select"
                                      value={accordion.pick_up_loc}
                                      aria-label="Default select example"
                                      name="pick_up_loc"
                                      onChange={(e) => {
                                        handleAccordianInputChange(accordion.id, 'pick_up_loc', e.target.value);
                                        updateLocationTypes(accordion.id, 'pickup', e.target.value);
                                      }}
                                    >
                                      <option value="">Select</option>
                                      {allLocations && allLocations.map((option, index) => (
                                        <option key={index} value={option.loc_id}>
                                          {[option?.loc_name, option?.loc_address, option?.state?.state_name, option?.loc_city, option?.loc_zip]
                                            .filter(Boolean)
                                            .join(', ')}
                                        </option>
                                      ))}
                                    </select>
                                    {errors[accordion.id]?.pick_up_loc && <span className="errors">{errors[accordion.id].pick_up_loc}</span>}
                                    {locationErrors[accordion.id] && (
                                      <span className="text-danger">{locationErrors[accordion.id]}</span>
                                    )}
                                    {locationTypes[`${accordion.id}_pickup`] && (
                                      <div style={{ fontStyle: 'italic', fontSize: '0.9em', color: 'green', marginTop: '4px' }}>
                                        Location Type: {locationTypes[`${accordion.id}_pickup`]}
                                      </div>
                                    )}
                                  </div>
                                  <div className="align-self-md-end d-flex gap-2">
                                    <PopupModal passId={selectedPassenger.value?.passenger?.passenger_id ?? ''} title="Add PickUp Location" toSetValue={setSetValue} locType='1' setValue={setLocationValue} addValue={locationValue} filterCriteria={1} handleResetAddValue={handleResetAddValue} />
                                    <IconButton aria-label="edit location" title="Edit Location" color="primary" onClick={() => setEditLocationOpen(true)}>
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  </div>
                                  <div>
                                    <div>
                                      <label className='require-field'>Drop off Time</label>
                                      <select name="drop_off_time" value={accordion.drop_off_time} className="form-select" id="drop_off_time" onChange={(e) => handleAccordianInputChange(accordion.id, 'drop_off_time', e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="Will Call">Will Call</option>
                                        {TIME_OPTIONS_5_MIN.map((t) => (
                                          <option key={t} value={t}>{t}</option>
                                        ))}

                                      </select>
                                    </div>
                                    {errors[accordion.id]?.drop_off_time && <span className="errors">{errors[accordion.id].drop_off_time}</span>}
                                  </div>
                                  <div>
                                    <label className='require-field'>Drop off Location</label>
                                    <div>
                                      <select className="form-select" value={accordion.drop_off_loc} aria-label="Default select example" name="drop_off_loc" onChange={(e) => {
                                        handleAccordianInputChange(accordion.id, 'drop_off_loc', e.target.value);
                                        updateLocationTypes(accordion.id, 'dropoff', e.target.value);
                                      }}>
                                        <option value="">Select</option>
                                        {allLocations && allLocations.map((option, index) => (
                                          <option key={index} value={option.loc_id}>
                                            {[option?.loc_name, option?.loc_address, option?.state?.state_name, option?.loc_city, option?.loc_zip]
                                              .filter(Boolean)
                                              .join(', ')}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    {errors[accordion.id]?.drop_off_loc && <span className="errors">{errors[accordion.id].drop_off_loc}</span>}
                                    {locationTypes[`${accordion.id}_dropoff`] && (
                                      <div style={{ fontStyle: 'italic', fontSize: '0.9em', color: 'green', marginTop: '4px' }}>
                                        Location Type: {locationTypes[`${accordion.id}_dropoff`]}
                                      </div>
                                    )}
                                  </div>
                                  <div className="align-self-md-end d-flex gap-2">
                                    <PopupModal passId={selectedPassenger.value?.passenger?.passenger_id ?? ''} title="Add DropOff Location" locType='2' toSetValue={setSetValue} setValue={setLocationValue} addValue={locationValue} filterCriteria={2} handleResetAddValue={handleResetAddValue} />
                                    <IconButton aria-label="edit location" title="Edit Location" color="primary" onClick={() => setEditLocationOpen(true)}>
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  </div>
                                </div>
                                {!isMAPayer ? null : null}
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))}

                  {/* Total Distance Display removed (manual miles input used for payload) */}

                  {/* Other Trip Details Section */}
                  <div style={{ marginTop: '20px' }}>
                    <p className="sub-title">Other Trip Details</p>
                    <div className="other-options-container" style={{
                      backgroundColor: '#e8f5e8',
                      padding: '20px',
                      borderRadius: '8px',
                      border: '1px solid #c3e6c3'
                    }}>

                      <div className="row">
                        <div className="col-2">
                          <label>Deadhead Miles</label>
                          <input
                            type="number"
                            className="form-control"
                            name="deadhead_miles"
                            value={scheduleDetails?.deadhead_miles}
                            placeholder="Enter miles"
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-2">
                          <label>Is There Any Wait Time</label>
                          <div>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={handleInputChange}
                              name="is_wait"
                              value={scheduleDetails.is_wait}
                            >
                              <option value="">Select</option>
                              <option value="0">No</option>
                              <option value="1">yes</option>
                            </select>
                          </div>
                          {errors.is_wait && <span className="errors">{errors.is_wait}</span>}
                        </div>

                        {showWaitTimeFields && (
                          <>
                            <div className="col-1">
                              <label>Hour</label>
                              <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control"
                                placeholder='Hr'
                                name='hour'
                                value={isEditingWaitHour ? (scheduleDetails.hour ?? '') : String(scheduleDetails.hour ?? '').padStart(2, '0')}
                                onChange={handleInputChange}
                                onFocus={(e) => {
                                  setIsEditingWaitHour(true);
                                  e.target.select();
                                }}
                                onBlur={() => {
                                  setIsEditingWaitHour(false);
                                  setScheduleDetails((prev) => {
                                    const raw = (prev.hour ?? '').toString().replace(/\D/g, '').slice(0, 2);
                                    const num = raw === '' ? 0 : Number(raw);
                                    const clamped = Math.min(24, isNaN(num) ? 0 : num);
                                    return { ...prev, hour: String(clamped).padStart(2, '0') };
                                  });
                                }}
                                style={{ fontSize: '14px' }}
                              />
                              {errors.hour && <span className="errors">{errors.hour}</span>}
                            </div>
                            <div className="col-1">
                              <label>Minute</label>
                              <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control"
                                placeholder='Min'
                                name='minute'
                                value={isEditingWaitMinute ? (scheduleDetails.minute ?? '') : String(scheduleDetails.minute ?? '').padStart(2, '0')}
                                onChange={handleInputChange}
                                onFocus={(e) => {
                                  setIsEditingWaitMinute(true);
                                  e.target.select();
                                }}
                                onBlur={() => {
                                  setIsEditingWaitMinute(false);
                                  setScheduleDetails((prev) => {
                                    const raw = (prev.minute ?? '').toString().replace(/\D/g, '').slice(0, 2);
                                    const num = raw === '' ? 0 : Number(raw);
                                    const clamped = Math.min(59, isNaN(num) ? 0 : num);
                                    return { ...prev, minute: String(clamped).padStart(2, '0') };
                                  });
                                }}
                                style={{ fontSize: '14px' }}
                              />
                              {errors.minute && <span className="errors">{errors.minute}</span>}
                            </div>
                          </>
                        )}

                        <div className={`col-2 ${!showWaitTimeFields ? '' : 'col-2'}`} style={{ paddingLeft: !showWaitTimeFields ? '0px' : '5px' }}>
                          <label>Door Assist</label>
                          <div className="d-flex gap-1 align-items-center mt-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="door_assist"
                                id="door_assist_yes"
                                value="2"
                                checked={scheduleDetails.door_assist == '2'}
                                onChange={handleInputChange}
                              />
                              <label className="form-check-label" htmlFor="door_assist_yes">Yes</label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="door_assist"
                                id="door_assist_no"
                                value="1"
                                checked={scheduleDetails.door_assist == '1'}
                                onChange={handleInputChange}
                              />
                              <label className="form-check-label" htmlFor="door_assist_no">No</label>
                            </div>
                          </div>
                        </div>

                        <div className={`col-2 ${!showWaitTimeFields ? '' : 'col-2'}`}>
                          <label className='require-field'>Are there any companions traveling?</label>
                          <div className="d-flex gap-3 align-items-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hasCompanions"
                                id="noCompanions"
                                value="No"
                                checked={hasCompanions === 'No'}
                                onChange={(e) => handleCompanionChange(e.target.value)}
                              />
                              <label className="form-check-label" htmlFor="noCompanions">No</label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hasCompanions"
                                id="yesCompanions"
                                value="Yes"
                                checked={hasCompanions === 'Yes'}
                                onChange={(e) => handleCompanionChange(e.target.value)}
                              />
                              <label className="form-check-label" htmlFor="yesCompanions">Yes</label>
                            </div>
                          </div>
                          {errors.has_companions && <span className="errors">{errors.has_companions}</span>}
                        </div>

                        {hasCompanions === 'Yes' && (
                          <div className="col-2">
                            <label className='require-field'>Number of Companions</label>
                            <div>
                              <input
                                type="text"
                                className="form-control"
                                id="companion_count"
                                name="companion_count"
                                value={companionCount}
                                placeholder="Companion count"
                                onChange={handleCompanionCountChange}
                                maxLength="2"
                              />
                              {errors.companion_count && <span className="errors">{errors.companion_count}</span>}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="client-notes">
                            <label>Notes</label>
                            <div>
                              <textarea className="alert alert-light" name="schedule_note" role="alert" style={{ width: '100%' }} onChange={handleInputChange} value={scheduleDetails.schedule_note}></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div className='footer-content' style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFormSubmit}>
                    UPDATE SCHEDULE
                  </Button>
                  <Button variant="contained" color="info" onClick={handleCancelSchedule}>
                    CANCEL SCHEDULE
                  </Button>
                  <CancelButton cancelHandler={() => navigate('/home/schedule/list/v1', { replace: true })} />
                </div>

              </form>
            </div>
          </section>
        </div>
        <ReusableModal
          open={editLocationOpen}
          onClose={() => setEditLocationOpen(false)}
          title="Edit Location"
          maxWidth="md"
        >
          <EditLocationContent
            passengerId={selectedPassenger.value?.passenger?.passenger_id ?? ''}
            onSaved={(updatedLocId) => {
              setEditLocationOpen(false);
              // Reload locations
              handleLocationSelect({ value: selectedPassenger.value });
              // If the edited location is currently selected in pick/drop, keep selects in sync
              setAccordions(prev => prev.map(acc => ({
                ...acc,
                pick_up_loc: String(acc.pick_up_loc) === String(updatedLocId) ? updatedLocId : acc.pick_up_loc,
                drop_off_loc: String(acc.drop_off_loc) === String(updatedLocId) ? updatedLocId : acc.drop_off_loc,
              })));
              // Update location type labels
              updateLocationTypes(1, 'pickup', accordions?.[0]?.pick_up_loc);
              updateLocationTypes(1, 'dropoff', accordions?.[0]?.drop_off_loc);
            }}
          />
        </ReusableModal>
      </div>
    </>
  );
};

export default ScheduleEditUpdated;
